import { UIElement } from '../ui-element.js';
import { element } from '../../global/template-literals.js';
import { Labels } from '../../global/labels.js';
import styles from './ui-skip-to-content.css';

/**
 * @memberof SharedComponents
 * @augments {UIElement}
 * @classdesc Represents a class for <code>ui-skip-to-content</code> element.
 * @alias UISkipToContent
 * @element ui-skip-to-content
 * @property {string} [href="#page"] {@attr href} A URL to an anchor to skip to. Must start with `#`.
 * <ui-skip-to-content href="#main-content">
 * </ui-skip-to-content>
 */
class UISkipToContent extends UIElement {
    /**
     * @type {Props}
     * @readonly
     */
    static get props() {
        return {
            attributes: {
                href: { type: String, default: '#page' },
            },
        };
    }

    /**
     * Define labels what could be localised
     * @type {Labels}
     * @readonly
     */
    static get labels() {
        return Labels.attach('ui-skip-to-content', {
            linkLabel: 'Skip to main content',
        });
    }

    /**
     * Renders template.
     * @private
     * @returns {DocumentFragment}
     */
    renderTemplate() {
        return element`<a
            class="ui-skip-to-content__link"
            href="${this.href}"
            >${UISkipToContent.labels.linkLabel}</a
        >`;
    }

    /**
     * @inheritDoc
     */
    render() {
        this.insertElements([this.renderTemplate()]);
    }

    /**
     * @inheritDoc
     */
    hydrate() {}
}

UISkipToContent.defineElement('ui-skip-to-content', styles);
export { UISkipToContent };
